import { useDefaultsLinkUpdate } from '../../../../../api/defaults/links'
import React, { useEffect } from 'react'
import { IDefaultLink, TSchemaAddLink } from '../../../../../api/types'
import { ErrorBoundary } from '@reapitform/utils'
import { LinkForm } from '../form-link'
import { Button, ButtonGroup } from '@reapit/elements'
import { Drawer } from '@reapitform/common-ui'

interface IUpdateLinkModalProps {
  defaultValues?: IDefaultLink
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDefaultLink[] | ((preData: IDefaultLink[]) => IDefaultLink[])) => void
}

export const UpdateLinkModal: React.FC<IUpdateLinkModalProps> = ({
  isOpen,
  onOpenChange,
  refreshList,
  defaultValues,
}) => {
  const { isLoading, updateLink, isSuccess, returnData } = useDefaultsLinkUpdate()
  const formId: string = React.useMemo(() => 'form-update-link', [])

  const handleClose = () => onOpenChange(false)
  const handleConfirm = (data: TSchemaAddLink) => {
    updateLink(data)
  }

  useEffect(() => {
    if (!isSuccess || !returnData) return

    refreshList((prevList) =>
      prevList.map((link) => {
        if (link.id !== returnData.id) return link
        return returnData
      }),
    )
    handleClose()
  }, [isSuccess, returnData])

  const DrawerFooter = React.useCallback(() => {
    return (
      <ButtonGroup alignment="right">
        <Button intent="default" disabled={isLoading} onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={isLoading} disabled={isLoading} intent="primary" type="submit" form={formId}>
          Update Link
        </Button>
      </ButtonGroup>
    )
  }, [handleClose, isLoading])

  if (!isOpen || !defaultValues) return null

  return (
    <ErrorBoundary>
      <Drawer isOpen={isOpen} onDrawerClose={handleClose} canDismiss footerItems={<DrawerFooter />} title="Edit Link">
        <LinkForm formId={formId} defaultValues={defaultValues} onSubmit={handleConfirm} />
      </Drawer>
    </ErrorBoundary>
  )
}
